import IncentiveProgramPanel from './incentiveProgramPanel.container';

export default IncentiveProgramPanel